import React, { Component } from 'react'
import style from './style.css'

export default class Wyswyg extends Component {
    componentDidMount( ) {
        this.refs.wyswyg.innerHTML = this.props.value
        this.refs.wyswyg.designMode = 'on'
    }

    command( command ) {
        document.execCommand(command, false, null)
        this.refs.wyswyg.focus()
    }

    onTextChange(e) {
        if(this.props.handleChange) {
            e.target.value = e.target.innerHTML
            this.props.handleChange(e)
        }
    }

    handleKeyDown(e) {
      let ctrl = e.ctrlKey || e.metaKey
      if(ctrl) {
         let keyCode = e.which || e.keyCode
         // 66 = b
         // 85 = i
         // 89 = u
         if(keyCode === 66) {
            this.command('bold')
            e.preventDefault()
            e.stopPropagation()
         }

         if(keyCode === 85) {
            this.command('italic')
            e.preventDefault()
            e.stopPropagation()
         }

         if(keyCode === 89) {
            this.command('underline')
            e.preventDefault()
            e.stopPropagation()
         }
      }
    }

    render() {
        return (
            <div className={style.boxField} style={this.props.style || {}}>
                <div className={style.actionBar}>
                    <button tabIndex='-1' className={style.btnAction} style={{ fontWeight: 'bold' }} onClick={() => this.command('bold')}>
                       <span className={`${style.wyswygicon} ${style.iconBold}`} />
                    </button>
                    <button tabIndex='-1' className={style.btnAction} style={{ fontStyle: 'italic' }} onClick={() => this.command('italic')}>
                       <span className={`${style.wyswygicon} ${style.iconItalic}`} />
                    </button>
                    <button tabIndex='-1' className={style.btnAction} style={{ textDecoration: 'underline' }} onClick={() => this.command('underline')}>
                       <span className={`${style.wyswygicon} ${style.iconUnderline}`} />
                    </button>

                    <span className={`${style.wyswygicon}`} />

                    <button tabIndex='-1' className={style.btnAction} onClick={() => this.command('insertOrderedList')}>
                       <span className={`${style.wyswygicon} ${style.iconOrderedList}`} />
                    </button>

                    <button tabIndex='-1' className={style.btnAction} onClick={() => this.command('insertUnorderedList')}>
                       <span className={`${style.wyswygicon} ${style.unorderedList}`} />
                    </button>
                </div>
                <div
                    className={`${style.text} ${style.wyswyg} ${this.props.value === '' ? style.comPlainTextContentEditable : ''} ${this.props.className || ''}`}
                    ref='wyswyg'
                    contentEditable
                    placeholder={this.props.placeholder || ''}
                    style={{
                        minHeight: this.props.height || '80px'
                    }}
                    onKeyDown={event => this.handleKeyDown(event)}
                    onInput={ e => this.onTextChange(e) }
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Forms/wyswyg.js